import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);

  // ⭐ Restore user after refresh
  useEffect(() => {

    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (token && role) {
      setUser({ role });
    }

  }, []);

  const login = (token, userData) => {

    localStorage.setItem("token", token);
    localStorage.setItem("role", userData.role);

    setUser(userData);

  };

  const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("role");

    setUser(null);

  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );

};